import { CountUp } from 'countup.js';

class CountUpNumber {
  constructor(params) {
    this.numberEl = params.el;
    this.numberString = this.numberEl.innerText
      .replace('.', '')
      .replace(',', '.');
    this.numberValue = parseFloat(this.numberString);
    this.duration = params.duration;
    this.countUpInstance = undefined;
    this.reducedMotionIsActive = window.matchMedia(
      '(prefers-reduced-motion)'
    ).matches;
    this.observer = undefined;
  }

  init = () => {
    if (this.reducedMotionIsActive) return;

    this.initIntersectionObserver();
  };

  destroy() {
    this.destroyIntersectionObserver();
  }

  decimalCount() {
    const splitNumber = this.numberString.split('.');
    if (splitNumber.length <= 1) return 0;
    return splitNumber[splitNumber.length - 1].length;
  }

  initCountUp() {
    const countUp = new CountUp(this.numberEl, this.numberValue, {
      separator: '.',
      decimal: ',',
      duration: this.duration || 2,
      decimalPlaces: this.decimalCount(),
    });

    if (!countUp.error) {
      countUp.start();
    } else {
      console.log(countUp.error);
    }
  }

  initIntersectionObserver() {
    this.observer = new IntersectionObserver(entries => {
      const isIntersecting = entries[0].isIntersecting;
      if (isIntersecting) {
        this.initCountUp();
        this.observer.unobserve(this.numberEl);
      }
    });

    this.observer.observe(this.numberEl);
  }

  destroyIntersectionObserver() {
    this.observer.disconnect();
  }
}

const elements = document.querySelectorAll('.fact-counter');
const instances = [];

elements.forEach(element => {
  const fact = new CountUpNumber({
    el: element.querySelector('.fact-counter__number'),
  });
  fact.init();
  instances.push(fact);
});
